import { Button } from '@fluentui/react-components';
import { Course as CourseTeamsServicesType } from '@mnspro-cloud/teams-services';
import { sortBy } from 'lodash';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CourseTile, CourseTileData } from '../../CourseTile';
import { TileGrid } from '../../TileGrid/TileGrid';

/**
 * Defines what to show on course click
 */
export enum MyCourseClickBehaviour {
  // Open classbook module
  Classbook,
  // Open course in "courses" module
  Course,
}

export interface MyCoursesWidgetCourseListProps {
  courses: (CourseTileData | CourseTeamsServicesType)[];
  onClick?: (courseId: string) => void;
  onOpenInBrowser?: (courseId: string) => void;
}

export const MyCoursesWidgetCourseList: React.FC<MyCoursesWidgetCourseListProps> = ({
  courses,
  onClick,
  onOpenInBrowser,
}) => {
  const { t } = useTranslation();
  const [showAll, setShowAll] = useState<boolean>(false);
  const collapsedCoursesCount = 7;
  const hasMore = !showAll && courses.length > collapsedCoursesCount;

  return (
    <div className="flex flex-col gap-3">
      <TileGrid>
        {sortBy(courses, ['courseName'])
          .slice(0, showAll ? undefined : collapsedCoursesCount)
          .map((course) => (
            <CourseTile
              key={course.id}
              course={course}
              onClick={onClick ? () => onClick?.(course.id) : undefined}
              onOpenInBrowser={onOpenInBrowser}
            />
          ))}
      </TileGrid>
      {hasMore && (
        <div className="flex justify-center">
          <Button appearance="transparent" onClick={() => setShowAll(!showAll)}>
            {t('dashboard:mycourses:show_all', { defaultValue: 'Alle anzeigen' })}
          </Button>
        </div>
      )}
    </div>
  );
};
